import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PhoneIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.81079 1.50275C7.30621 2.22994 7.66652 3.18437 7.84667 4.22969C7.93675 4.63873 7.62148 4.95688 7.35125 5.18412L6.3604 5.82041C5.63979 6.32035 8.97263 11.7288 9.73828 11.3198L10.7742 10.6835C11.0444 10.5017 11.4948 10.3653 11.81 10.638C12.6658 11.2743 13.3413 12.0015 13.7917 12.7741C14.0019 13.1074 13.3113 13.9104 11.72 15.1829C8.20698 17.0009 0.595501 4.68418 3.74818 2.32084C5.57974 1.44215 6.60061 1.16946 6.81079 1.50275Z"
		/>
	</svg>
))
